import { Component, Inject, OnInit } from '@angular/core';
import { filter, map, take } from 'rxjs/operators';
import { FeatureTogglesFacade } from '@cigna/features';
import { UserFacade } from '@cigna/chcp/shared/user-profile-data-access';
import { AuthFacade } from '@cigna/chcp/auth/data-access';
import { DashboardFacade } from '@cigna/chcp/dashboard/data-access';
import {
  Entitlement,
  LOB,
  LOB_MEDBH,
  LOB_MEDICAL,
} from '@cigna/chcp/auth/util';
import { APP_CONTEXT } from '@cigna/chcp/shared/environment-util';
import { AppContext } from '@cigna/chcp/shared/util';
import { defaultMessageCenterFilters } from '@cigna/chcp/shared/message-center-data-access';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'cigna-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  firstName$ = this.userFacade.firstName$;
  contactUpdated$ = this.userFacade.contactUpdated$;
  impersonator$ = this.authFacade.isImpersonator$;
  restrictedImpersonator$ = this.authFacade.isRestrictedImpersonator$;

  hasClaimSearch$ = this.authFacade.hasOneOfEntitlements$([
    Entitlement.ClaimsSearch,
  ]);
  isOhpUser$ = this.authFacade.isOhpUser$;
  isDentalUser$ = this.authFacade.isDentalUser$;
  hasPatientSearch$ = this.authFacade.hasOneOfEntitlements$([
    Entitlement.PatientSearch,
  ]);
  hasDelegation$ = this.authFacade.hasOneOfEntitlements$([
    Entitlement.DelegationAccessAndViews,
  ]);
  hasPrecertification$ = this.authFacade.hasOneOfEntitlements$([
    Entitlement.Precertification,
  ]);

  messageCenterFeatureFlag$ = combineLatest([
    this.featureToggleFacade.featuresEnabled(['claim360GA']),
    this.authFacade.lob$,
    this.authFacade.hasAllEntitlements$([Entitlement.ClaimsSearch]),
  ]).pipe(
    map(
      ([gaFlag, lob, claimEntitlement]) =>
        gaFlag &&
        claimEntitlement &&
        [LOB_MEDBH, LOB_MEDICAL].includes(lob as LOB),
    ),
  );

  latestUpdates$ = this.dashboardFacade.latestUpdates$;
  newFeatures$ = this.dashboardFacade.newFeatures$;
  newFeatureBanners$ = this.dashboardFacade.newFeatureBanners$;
  latestUpdatesLoading$ = this.dashboardFacade.latestUpdatesLoading$;
  messages$ = this.dashboardFacade.messages$;

  constructor(
    private userFacade: UserFacade,
    private authFacade: AuthFacade,
    private featureToggleFacade: FeatureTogglesFacade,
    public dashboardFacade: DashboardFacade,
    @Inject(APP_CONTEXT) public appContext: AppContext,
  ) {}

  ngOnInit() {
    combineLatest([this.authFacade.lob$, this.messageCenterFeatureFlag$])
      .pipe(
        filter(([lob, flag]) => lob !== undefined && lob !== null),
        take(1),
      )
      .subscribe(([lob, flag]) => {
        this.dashboardFacade.getLatestUpdates();

        if (flag) {
          this.dashboardFacade.fetchMessages(defaultMessageCenterFilters);
        }
      });
  }
}
